import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
//import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import AddEditCategoryModal from "./addEditModal";
import { deleteCategory } from "../../redux/actions/category-action-types";
import DeleteModal from "../../components/deleteModal";
//import { DateTime } from "luxon";
import moment from "moment";
import DataTable from 'react-data-table-component';

import { sortArrayOfObjects } from "../../utilities/methods";

const customStyles = {
  headCells: {
    style: {
      paddingLeft: '8px', 
      paddingRight: '8px',
      fontSize:'18px',
      fontWeight:'bold'
    },
  },
};

function Category() {
  /** State Variables */
  const [_categories, setCategories] = useState([]),
    [orderby, setOrderBy] = useState("createdAt"),
    [sortby, setSortby] = useState("desc"),
    [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false),
    [selectedCategory, setSelectedCategory] = useState(null),
    [columns, setColumns] = useState([]),
    [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    
    
  /** Redux Variables */
  const categories = useSelector((state) => state.category?.categories);

  useEffect(() => {
    let filteredCategories = categories.sort(
      sortArrayOfObjects(orderby, sortby)
    );
    setCategories([...filteredCategories]);
    setColumns([
      {
        name: 'Serial No.',
        cell: (row, index) => index + 1  
      },
      {
         name: 'Title',
         selector: 'title',
         sortable: true
      },
      {
        name: 'Added On',
        cell: row =>{
          return(
             <span>
                {moment(parseInt(row.createdAt)).format("ll")}
             </span>
          )
        },
        selector: 'createdAt',
        sortable: true,
      },
      {
        name: 'Action',
        cell: row => {return(
          <div>
          <button
            className="btn btn-link  p-0 mr-3"
            onClick={(e) => toggleAddEditModal(e, row)}
          >
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.7915 2.83203H2.83317C2.45745 2.83203 2.09711 2.98129 1.83144 3.24696C1.56576 3.51264 1.4165 3.87297 1.4165 4.2487V14.1654C1.4165 14.5411 1.56576 14.9014 1.83144 15.1671C2.09711 15.4328 2.45745 15.582 2.83317 15.582H12.7498C13.1256 15.582 13.4859 15.4328 13.7516 15.1671C14.0172 14.9014 14.1665 14.5411 14.1665 14.1654V9.20703"
                stroke="#FF7E06"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.104 1.77213C13.3858 1.49034 13.768 1.33203 14.1665 1.33203C14.565 1.33203 14.9472 1.49034 15.229 1.77213C15.5108 2.05393 15.6691 2.43612 15.6691 2.83463C15.6691 3.23315 15.5108 3.61534 15.229 3.89713L8.49984 10.6263L5.6665 11.3346L6.37484 8.5013L13.104 1.77213Z"
                stroke="#FF7E06"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            className="btn btn-link p-0"
            onClick={(e) => toggleDeleteModal(e, row)}
          >
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4.19922H2.6H15.4"
                stroke="#F00000"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z"
                stroke="#F00000"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.60059 8.19922V12.9992"
                stroke="#F00000"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.7998 8.19922V12.9992"
                stroke="#F00000"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          </div>
        )}
      }
    ])
  }, [categories, orderby, sortby]);

  const toggleAddEditModal = (e, category = null, type) => {
    
    setSelectedCategory(category);
    if(category){
      setIsOpenAddEditModal(true);
    }else if(type === "add"){
      setIsOpenAddEditModal(true);
    }
    else{
      setIsOpenAddEditModal(false);
    }
    
  };

  const toggleDeleteModal = (e, category = null) => {
    setSelectedCategory(category);
    if(category){
      setIsOpenDeleteModal(true);
    }else{
      setIsOpenDeleteModal(false);
    }
    
  };

  /*const sort = (e, orderby, sortby) => {
    e.preventDefault();
    setOrderBy(orderby);
    setSortby(sortby);
  };*/

  /*const createCategory = () => {};*/

  return (
    <div className="mainContentWrapper">
      <div className="dashContentHeader d-flex justify-content-between align-items-center">
        <div>
          <h5 className="dashHeading mb-0">Category</h5>
        </div>
        <div>
          <button
            onClick={(e)=>{toggleAddEditModal(e, null, "add")}}
            className="sub-button"
            data-toggle="modal"
            data-target="#addCategory"
          >
            Add Category
          </button>
        </div>
      </div>
      <div className=" table-responsive cat-firsttd">
        {/*<table className="table table-striped m-0">
          <thead>
            <tr>
              <th style={{ width: "90px" }}>S.R.</th>
              <th>Title</th>
              <th>
                Added on &nbsp;
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.0915 4.50796L3.99983 2.59129L5.90816 4.50796C5.98563 4.58606 6.0778 4.64806 6.17935 4.69037C6.2809 4.73267 6.38982 4.75446 6.49983 4.75446C6.60984 4.75446 6.71876 4.73267 6.82031 4.69037C6.92186 4.64806 7.01403 4.58606 7.0915 4.50796C7.1696 4.43049 7.2316 4.33832 7.2739 4.23677C7.31621 4.13522 7.33799 4.0263 7.33799 3.91629C7.33799 3.80628 7.31621 3.69736 7.2739 3.59581C7.2316 3.49426 7.1696 3.40209 7.0915 3.32462L4.5915 0.824624C4.51403 0.746517 4.42186 0.684522 4.32031 0.642214C4.21876 0.599907 4.10984 0.578125 3.99983 0.578125C3.88982 0.578125 3.7809 0.599907 3.67935 0.642214C3.5778 0.684522 3.48563 0.746517 3.40816 0.824624L0.908162 3.32462C0.751243 3.48154 0.663086 3.69437 0.663086 3.91629C0.663086 4.13821 0.751243 4.35104 0.908162 4.50796C1.06508 4.66488 1.27791 4.75303 1.49983 4.75303C1.72175 4.75303 1.93458 4.66488 2.0915 4.50796ZM5.90816 8.32462L3.99983 10.2413L2.0915 8.32462C2.0138 8.24692 1.92156 8.18529 1.82004 8.14324C1.71852 8.10119 1.60971 8.07955 1.49983 8.07955C1.38995 8.07955 1.28114 8.10119 1.17962 8.14324C1.0781 8.18529 0.985861 8.24692 0.908162 8.32462C0.830464 8.40232 0.768829 8.49456 0.726779 8.59608C0.684729 8.6976 0.663086 8.80641 0.663086 8.91629C0.663086 9.02617 0.684729 9.13498 0.726779 9.2365C0.768829 9.33802 0.830464 9.43026 0.908162 9.50796L3.40816 12.008C3.48563 12.0861 3.5778 12.1481 3.67935 12.1904C3.7809 12.2327 3.88982 12.2545 3.99983 12.2545C4.10984 12.2545 4.21876 12.2327 4.32031 12.1904C4.42186 12.1481 4.51403 12.0861 4.5915 12.008L7.0915 9.50796C7.24841 9.35104 7.33657 9.13821 7.33657 8.91629C7.33657 8.69437 7.24841 8.48154 7.0915 8.32462C6.93458 8.1677 6.72175 8.07955 6.49983 8.07955C6.27791 8.07955 6.06508 8.1677 5.90816 8.32462Z"
                    fill="#9E9E9E"
                  />
                </svg>
              </th>
              <th width="160px">Actions</th>
            </tr>
          </thead>
          <tbody>
            {_categories.map((category, index) => (
              <tr key={index}>
                <td> {index + 1}</td>
                <td> {category.title}</td>
                <td>
                  {DateTime.fromMillis(Number(category.createdAt)).toFormat(
                    "dd-MM-yyyy hh:mm a"
                  )}
                </td>

                <td width="160px">
                  <div>
                    <button
                      className="btn btn-link  p-0 mr-3"
                      onClick={(e) => toggleAddEditModal(e, category)}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.7915 2.83203H2.83317C2.45745 2.83203 2.09711 2.98129 1.83144 3.24696C1.56576 3.51264 1.4165 3.87297 1.4165 4.2487V14.1654C1.4165 14.5411 1.56576 14.9014 1.83144 15.1671C2.09711 15.4328 2.45745 15.582 2.83317 15.582H12.7498C13.1256 15.582 13.4859 15.4328 13.7516 15.1671C14.0172 14.9014 14.1665 14.5411 14.1665 14.1654V9.20703"
                          stroke="#FF7E06"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.104 1.77213C13.3858 1.49034 13.768 1.33203 14.1665 1.33203C14.565 1.33203 14.9472 1.49034 15.229 1.77213C15.5108 2.05393 15.6691 2.43612 15.6691 2.83463C15.6691 3.23315 15.5108 3.61534 15.229 3.89713L8.49984 10.6263L5.6665 11.3346L6.37484 8.5013L13.104 1.77213Z"
                          stroke="#FF7E06"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      className="btn btn-link p-0"
                      onClick={(e) => toggleDeleteModal(e, category)}
                    >
                      <svg
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 4.19922H2.6H15.4"
                          stroke="#F00000"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z"
                          stroke="#F00000"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.60059 8.19922V12.9992"
                          stroke="#F00000"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.7998 8.19922V12.9992"
                          stroke="#F00000"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>*/}
        {_categories && 
            <DataTable
              striped={true}
              className="categoryListingTable bg-white p-14 "
              highlightOnHover={true}
              pagination={true}
              paginationPerPage={10}
              title=""
              columns={columns}
              data={_categories}
              customStyles={customStyles}
              paginationIconPrevious={<svg width="32" height="32" fill="none"><path d="M27 16H5M14 7l-9 9 9 9" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>}
              paginationIconNext={<svg width="32" height="32" fill="none"><path d="M5 16h22M18 7l9 9-9 9" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>}
              paginationComponentOptions={{ 
                noRowsPerPage: false,
                selectAllRowsItem:false 
              }}
          />
          }
      </div>
      <AddEditCategoryModal
        isOpen={isOpenAddEditModal}
        toggle={toggleAddEditModal}
        category={selectedCategory}
      />
      {selectedCategory && (
        <DeleteModal
          isOpen={isOpenDeleteModal}
          toggle={toggleDeleteModal}
          id={selectedCategory.id}
          method={deleteCategory}
          content={`Are you sure you want to delete '${selectedCategory.title}' category?`}
        />
      )}

      {/* <Modal
        isOpen={isOpenAddEditModal}
        toggle={toggleAddEditModal}
      >
        <ModalHeader
          className="modal-header px-4"
          toggle={toggleAddEditModal}
        >
          <h5 className="modal-title" id="#addCategorylabel">
            Create a new category
          </h5>
        </ModalHeader>
        <ModalBody className="modal-body px-4 py-5">
          <div>
            <form className="pb-2">
              <div className="saveInput">
                <label className="text-uppercase">CATEGORY Name</label>
                <div className="d-flex">
                  <input type="Livestock" id="" />
                  <button className="btn border-0" onClick={createCategory}>
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal> */}
    </div>
  );
}

export default Category;
